<template>
  <transition name="fades">
    <div
      class="modal"
      v-if="visible"
      id='guanshan_app_modal_id'
    >
      <div class="share_box">
        <div
          class="share_box_title msp_icon_close el-message-box__header"
          style="clear:both;"
        >
          <span>推送服务</span>
          <span
            class="el-icon-close"
            @click='closeModal'
            style="float:right;line-height:48px;margin-right:20px;cursor:pointer;"
          ></span>
        </div>
        <iframe
          :src="iframeUrl"
          frameborder="0"
        ></iframe>
      </div>
    </div>
  </transition>
</template>

<script>

import * as api from '../../../api'
import logsMixins from '../../../mixins/logs'

export default {
  components: {

  },

  data () {
    return {
      visible: false,
      currentArticleData: '',
      iframeUrl: '',
      toasttStatus: false,
      pushIndex: 0,
      articleIdList: []
    }
  },
  mixins: [logsMixins],
  mounted () {
    this.receiveMessage()
    this.$root.eventHub.$on('pushEachServiceModel', (data, id, temkey, ids) => {
      this.visible = true
      this.currentArticleData = data
      this.articleIdList = ids
      var currentIframeUrl = ''
      var newMediaType = ''
      switch (id) {
        case 'id_gsh_app':
          currentIframeUrl = '#/guanshanapp'
          break;
        case 'id_gsh_app_batch':
          currentIframeUrl = '#/guanshanapp'
          break;
        case 'id_zhongwang_app_v2':
          currentIframeUrl = '#/zhongwangpush'
          break;
        case 'id_gognorthnet':
          currentIframeUrl = '#/pcpush'
          break;
        case 'id_sinan_app':
          currentIframeUrl = '#/sinanapp'
          break;
        case 'id_gsh_micro_site':
          currentIframeUrl = '#/weizhan'
          break;
        case 'id_bh_cms_site':
          currentIframeUrl = '#/cmssitepush'
          break;
        case 'id_pingtang_site':
          currentIframeUrl = '#/pingtangpush'
          break;
        case 'id_pingtang_app':
          currentIframeUrl = '#/pingtangapppush'
          break;
        case 'id_old_gsh_app':
          currentIframeUrl = '#/oldguanshanapp'
          break;
        case 'id_sandu_cms_app':
          currentIframeUrl = '#/sanduapppush'
          break;
        case 'id_sinan_sobey':
          currentIframeUrl = '#/sinansuobeipush'
          break;
        case 'id_pingtang_bh_site':
          currentIframeUrl = '#/pingtangbohongpush'
          break;
        case 'id_bhws_app':
          currentIframeUrl = '#/bohongwanshanpush'
          break;
        case 'id_distribution_weibo':
          newMediaType = 'weibo'
          currentIframeUrl = '#/douyinweibopush'
          break;
        case 'id_distribution_douyin':
          newMediaType = 'douyin'
          currentIframeUrl = '#/douyinweibopush'
          break;
        case 'id_distribution_toutiao':
          newMediaType = 'toutiao'
          currentIframeUrl = '#/douyinweibopush'
          break;
        case 'id_gzu_cms':
          currentIframeUrl = '#/guizhouunypush'
          break;
        case 'id_mrp_cms':
          currentIframeUrl = '#/mrpcmspush'
          break;
        case 'id_dcy_wa_app':
          currentIframeUrl = '#/dcywaapppush'
          break;
        case 'id_zw_app':
          currentIframeUrl = '#/zwapp'
          break;
        case 'id_gzvcfe_cms':
          currentIframeUrl = '#/gzvcfecms'
          break;
        case 'id_kaili_xueyuan':
          currentIframeUrl = '#/kailixycmspush'
          break;
      }
      if (id === 'id_sinan_sobey') {
        this.iframeUrl = _IFRAMEPUSHURL_ + currentIframeUrl + '#/' + '?userId=' + this.userId + '&token=' + this.token + '&seed=' + this.seed + '&orgId=' + this.orgId + '&id_content=' + data.id + '&title=' + encodeURI(data.title) + '&type=' + 'article'
      } else if (id === 'id_zhongwang_app') {
        this.iframeUrl = _IFRAMEPUSHURL_ + currentIframeUrl + '#/' + '?userId=' + this.userId + '&token=' + this.token + '&seed=' + this.seed + '&orgId=' + this.orgId + '&id_content=' + data.id + '&title=' + encodeURI(data.title) + '&sourceName=' + data.source + '&type=' + 'article'
      } else if (id === 'id_distribution_weibo' || id === 'id_distribution_douyin' || id === 'id_distribution_toutiao') {
        this.iframeUrl = _IFRAMEPUSHURL_ + currentIframeUrl + '#/' + '?userId=' + this.userId + '&token=' + this.token + '&seed=' + this.seed + '&orgId=' + this.orgId + '&id_content=' + data.id + '&title=' + encodeURI(data.title) + '&newMediaType=' + newMediaType + '&type=' + 'article' + '&pushPointId=' + id
      } else if (id === 'id_gsh_app_batch') {
        this.iframeUrl = _IFRAMEPUSHURL_ + currentIframeUrl + '#/' + '?userId=' + this.userId + '&token=' + this.token + '&seed=' + this.seed + '&orgId=' + this.orgId + '&temkey=' + temkey
      } else {
        var list_header_img = 0
        if (data && data.list_header_img) {
          list_header_img = data.list_header_img.length
        } else {
          list_header_img = 0
        }
        this.iframeUrl = _IFRAMEPUSHURL_ + currentIframeUrl + '#/' + '?userId=' + this.userId + '&token=' + this.token + '&seed=' + this.seed + '&orgId=' + this.orgId + '&id_content=' + data.id + '&title=' + encodeURI(data.title) + '&headImgNum=' + list_header_img
      }

    })
  },

  destroyed () {
    this.$root.eventHub.$off('pushEachServiceModel')
  },
  computed: {
    userId () {
      return this.$store.state.userinfo.usercode
    },
    token () {
      return this.$store.state.userinfo.token
    },
    seed () {
      return this.$store.state.userinfo.seed
    },
    orgId () {
      return this.$store.state.userinfo.company_id
    }

  },
  methods: {
    closeModal () {
      this.visible = false
      this.iframeUrl = ''
    },
    receiveMessage () {
      var self = this
      var receiveMessageInfo = function (e) {
        self.visible = false
        self.iframeUrl = ''
        if (e.data && (typeof (e.data) == 'string') && (e.data.indexOf('success') != -1)) {
          if (self.currentArticleData && self.currentArticleData.hasOwnProperty('flag_push')) {
            self.$set(self.currentArticleData, 'flag_push', 'yes')
          }
          if (self.currentArticleData && self.currentArticleData.hasOwnProperty('id')) {
            self.getOperateLogs(self.currentArticleData.id)
          }
          if (self.$route.path === "/editorArticle") {
            try {
              window.opener.postMessage(self.currentArticleData, '*')
            } catch (error) {
              console.log(error)
            }
          }
          if (self.$route.path === "/manuscriptrepo/repomanuscript" || self.$route.path === "/documentrepo/repomanuscript") {
            self.$root.eventHub.$emit('setFlagPushStatus', self.currentArticleData, 'yes')
          }

        } else {
          self.$root.eventHub.$emit('setFlagPushBatchStatus', self.articleIdList)
        }
      }
      window.addEventListener("message", receiveMessageInfo, false);
    }
  },
  watch: {
    visible () {
      if (this.visible == false) {
        this.iframeUrl = ''
        this.pushIndex = 0
      }
    }
  }
}
</script>

<style scoped>
@import "../../../static/css/modal.css";

ul,
li {
  list-style: none;
}
</style>
